import { Injectable } from '@angular/core';
import axios from 'axios';
import { FiltersService } from './filters.service';
import { ContractModel } from 'src/app/global/contract-filter-model';
import { MetricDetailsRequest } from 'src/app/global/metric-details';
import { HttpClientService } from './http-client.service';
import { ServiceCustomerFilterOptions } from 'src/app/global/service-customer-model';
import { AdvancedOneCustomerFilters } from 'src/app/config/GlobalCacheLoader.service';
import { FilterRequests } from './filter-requests.service';
import { ServiceMetricTypes, SICallTypes } from 'src/app/features/service-insights/types/service-insight-types';
import { FilterSet } from 'src/app/global/filter-model';
import { CurrencyUomService } from './currency-uom.service';

@Injectable({
  providedIn: 'root',
})
export class ServiceInsightsRequests {
  private ENDPOINT_BASE_PATH: string = '/service-insights';
  private filterRequest: ContractModel | undefined;
  private oneCustomerName: string = '';
  private advancedOneCustomerFilters : AdvancedOneCustomerFilters | undefined;
  private ExcludeDeletedAccounts: boolean = false;
  private filterSet: FilterSet | undefined;

  constructor(
    private httpClientService: HttpClientService,
    private filterService: FiltersService,
    private filterRequests: FilterRequests,
    private currencyUomService: CurrencyUomService
  ) {
    this.filterService.selectedFiltersObservable.subscribe(
      (f) => (this.filterRequest = f)
    );
    this.filterService.oneCustomerNameObservable.subscribe(f => this.oneCustomerName = f);
    this.filterService.oneCustomerFiltersObservable.subscribe(f => this.advancedOneCustomerFilters = f);
    this.filterRequests.excludeDeletedAccountsObservable.subscribe(f => this.ExcludeDeletedAccounts = f);
    this.filterService.filterSetObservable.subscribe(f => this.filterSet = f);

  }

  async getSIMetricByPeriod(
    metricType: ServiceMetricTypes,
    metricObsType: SICallTypes,
    serviceCustomerFilters: ServiceCustomerFilterOptions
  ) {
    let filterData: ContractModel | undefined =
      this.filterService.selectedFilters.getValue();

    try {
      if (filterData == undefined) {
        throw new Error('filterData is undefined');
      }

      const payload = {
        division: filterData.division,
        dataView: filterData.dataView,
        topLevelContractGroup: filterData.topLevelContractGroup,
        secondLevelContractFilter: filterData.secondLevelContractFilter,
        thirdLevelContractFilter: filterData.thirdLevelContractFilter,
        fourthLevelContractFilter: filterData.fourthLevelContractFilter,
        accts: filterData.accts,
        serviceCustomerFilters: serviceCustomerFilters,
        oneCustomerName: this.oneCustomerName,
        oneCustomerFilters: this.advancedOneCustomerFilters,
        excludeDeletedAccounts: filterData.excludeDeletedAccounts
      };

      let url = `${this.ENDPOINT_BASE_PATH}/${metricType}/${metricObsType}/by-period?region=${filterData.regions}&countries=${filterData.countries}&period=${filterData.period}`;
      url = this.filterService.appendCustomDateRangeToUrl(url);
      return await this.httpClientService.post(
        url,
        payload
      );
    } catch (error) {
      console.error('Error fetching data:', error);
      return axios('fail');
    }
  }

  async getSIMetricByLocationFromAPI(
    metricType: ServiceMetricTypes,
    metricObsType: SICallTypes,
    serviceCustomerFilters: ServiceCustomerFilterOptions) {
    let filterData: ContractModel | undefined =
      this.filterService.selectedFilters.getValue();

    if (filterData == undefined) {
      throw new Error('filterData is undefined');
    }

    const payload = {
      division: filterData.division,
      dataView: filterData.dataView,
      topLevelContractGroup: filterData.topLevelContractGroup,
      secondLevelContractFilter: filterData.secondLevelContractFilter,
      thirdLevelContractFilter: filterData.thirdLevelContractFilter,
      fourthLevelContractFilter: filterData.fourthLevelContractFilter,
      accts: filterData.accts,
      serviceCustomerFilters: serviceCustomerFilters,
      oneCustomerName: this.oneCustomerName,
      oneCustomerFilters: this.advancedOneCustomerFilters,
      excludeDeletedAccounts: filterData.excludeDeletedAccounts
    };

    let url = `${this.ENDPOINT_BASE_PATH}/${metricType}/${metricObsType}/by-location?region=${filterData.regions}&countries=${filterData.countries}&period=${filterData.period}`;
    url = this.filterService.appendCustomDateRangeToUrl(url);
    return await this.httpClientService.post(
      url,
      payload
    );
  }

  async getSIMetricByIssuesFromAPI(
    metricType: ServiceMetricTypes,
    metricObsType: SICallTypes,
    serviceCustomerFilters: ServiceCustomerFilterOptions) {
    let filterData: ContractModel | undefined =
      this.filterService.selectedFilters.getValue();

    if (filterData == undefined) {
      throw new Error('filterData is undefined');
    }

    const payload = {
      division: filterData.division,
      dataView: filterData.dataView,
      topLevelContractGroup: filterData.topLevelContractGroup,
      secondLevelContractFilter: filterData.secondLevelContractFilter,
      thirdLevelContractFilter: filterData.thirdLevelContractFilter,
      fourthLevelContractFilter: filterData.fourthLevelContractFilter,
      accts: filterData.accts,
      serviceCustomerFilters: serviceCustomerFilters,
      oneCustomerName: this.oneCustomerName,
      oneCustomerFilters: this.advancedOneCustomerFilters,
      excludeDeletedAccounts: filterData.excludeDeletedAccounts
    };

    let url = `${this.ENDPOINT_BASE_PATH}/${metricType}/${metricObsType}/by-issue?region=${filterData.regions}&countries=${filterData.countries}&period=${filterData.period}`;
    url = this.filterService.appendCustomDateRangeToUrl(url);
    return await this.httpClientService.post(
      url,
      payload
    );
  }

  async getSITotalCallsByType(
    metricType: ServiceMetricTypes,
    serviceCustomerFilters: ServiceCustomerFilterOptions) {
    let filterData: ContractModel | undefined =
      this.filterService.selectedFilters.getValue();

    if (filterData == undefined) {
      throw new Error('filterData is undefined');
    }

    const payload = {
      division: filterData.division,
      dataView: filterData.dataView,
      topLevelContractGroup: filterData.topLevelContractGroup,
      secondLevelContractFilter: filterData.secondLevelContractFilter,
      thirdLevelContractFilter: filterData.thirdLevelContractFilter,
      fourthLevelContractFilter: filterData.fourthLevelContractFilter,
      accts: filterData.accts,
      serviceCustomerFilters: serviceCustomerFilters,
      oneCustomerName: this.oneCustomerName,
      oneCustomerFilters: this.advancedOneCustomerFilters,
      excludeDeletedAccounts: this.ExcludeDeletedAccounts
    };

    let url = `${this.ENDPOINT_BASE_PATH}/${metricType}/${SICallTypes.TotalCalls}/by-type?region=${filterData?.regions}&countries=${filterData?.countries}&period=${filterData?.period}`;
    url = this.filterService.appendCustomDateRangeToUrl(url);
    return await this.httpClientService.post(
      url,
      payload
    );
  }

  // TODO: getSIMetricByPeriod, getSIMetricByLocationFromAPI, getSIMetricByIssuesFromAPI, and getSITotalCallsByType
  // (by-period/by-type calls) could be migrated to this summary endpoint, but are still used by Pest and the drilldown page.
  async getSIMetricCountsSummary() {
    try {
      if (this.filterSet == undefined) {
        throw new Error('filterData is undefined');
      }
      const payload = {
        ...this.filterSet,
        CurrencyCode: this.currencyUomService.getCurrency(),
        UnitOfMeasure: this.currencyUomService.getUom(),
      };
      let url = `${this.ENDPOINT_BASE_PATH}/metric-counts-summary`;
      return await this.httpClientService.post(
        url,
        payload
      );
    } catch (error) {
      console.error('Error getting service details KPI data', error);
      return axios('fail');
    }
  }

  async getSIExpandedMetricDetails(request: MetricDetailsRequest) {
    if (request == undefined) {
      return null;
    }

    let filterData: ContractModel | undefined =
      this.filterService.selectedFilters.getValue();

    if (filterData == undefined) throw new Error('filterData is undefined');


    // if filtered data is required then make the api call to expanded with graph filter
    const payload = {
      graphDetailFilter: request?.graphDetailFilter,
      contractModel: {
        division: filterData.division,
        dataView: filterData.dataView,
        topLevelContractGroup: filterData.topLevelContractGroup,
        secondLevelContractFilter: filterData.secondLevelContractFilter,
        thirdLevelContractFilter: filterData.thirdLevelContractFilter,
        fourthLevelContractFilter: filterData.fourthLevelContractFilter,
        accts: filterData.accts,
        serviceCustomerFilters: request?.serviceCustomerFilters,
        oneCustomerName: this.oneCustomerName,
        oneCustomerFilters: this.advancedOneCustomerFilters,
        excludeDeletedAccounts: filterData.excludeDeletedAccounts
      },
    };

    if (request.serviceType == undefined || request.metricDetailType == undefined) {
      return;
    }

    let url = `${this.ENDPOINT_BASE_PATH}/expanded/${request.serviceType}/${request.metricDetailType}?region=${filterData?.regions}&countries=${filterData?.countries}&period=${filterData?.period}&limit=${request.limit}&page=${request.page}&sortBy=${request.sortBy}&sortOrder=${request.sortOrder}`;
    url = this.filterService.appendCustomDateRangeToUrl(url);
    return await this.httpClientService.post(
      url,
      payload
    );
  }

  async getSIExpandedPhotos(
    specificInfo: {
      callType: SICallTypes;
      groupType: string;
      serviceCustomerFilters: ServiceCustomerFilterOptions;
      limit: number;
      page: number;
    }
  ) {
    let filterData: ContractModel | undefined =
      this.filterService.selectedFilters.getValue();

    if (filterData == undefined) {
      throw new Error('filterData is undefined');
    }

    const payload = {
      division: filterData.division,
      dataView: filterData.dataView,
      topLevelContractGroup: filterData.topLevelContractGroup,
      secondLevelContractFilter: filterData.secondLevelContractFilter,
      thirdLevelContractFilter: filterData.thirdLevelContractFilter,
      fourthLevelContractFilter: filterData.fourthLevelContractFilter,
      accts: filterData.accts,
      serviceCustomerFilters: specificInfo.serviceCustomerFilters,
      oneCustomerName: this.oneCustomerName,
      oneCustomerFilters: this.advancedOneCustomerFilters,
      excludeDeletedAccounts: filterData.excludeDeletedAccounts
    };

    let url = `${this.ENDPOINT_BASE_PATH}/expanded/photo/${specificInfo.groupType}?callType=${specificInfo.callType}&region=${filterData.regions}&countries=${filterData.countries}&period=${filterData.period}&page=${specificInfo.page}&limit=${specificInfo.limit}`;
    url = this.filterService.appendCustomDateRangeToUrl(url);
    return await this.httpClientService.post(
      url,
      payload
    );
  }

  async getTopBottomLocationInsights() {
    let filterData: ContractModel | undefined =
      this.filterService.selectedFilters.getValue();

    if (filterData == undefined) {
      throw new Error('filterData is undefined');
    }

    const payload = {
      division: filterData.division,
      dataView: filterData.dataView,
      topLevelContractGroup: filterData.topLevelContractGroup,
      secondLevelContractFilter: filterData.secondLevelContractFilter,
      thirdLevelContractFilter: filterData.thirdLevelContractFilter,
      fourthLevelContractFilter: filterData.fourthLevelContractFilter,
      accts: filterData.accts,
      oneCustomerName: this.oneCustomerName,
      oneCustomerFilters: this.advancedOneCustomerFilters,
      excludeDeletedAccounts: this.ExcludeDeletedAccounts
    };

    let url = `${this.ENDPOINT_BASE_PATH}/locations?region=${filterData?.regions}&countries=${filterData?.countries}&period=${filterData?.period}`;
    url = this.filterService.appendCustomDateRangeToUrl(url);
    return await this.httpClientService.post(
      url,
      payload
    );
  }

  async getServiceInsights(issueType: string) {
    let filterData: ContractModel | undefined =
      this.filterService.selectedFilters.getValue();

    if (filterData == undefined) {
      throw new Error('filterData is undefined');
    }

    const payload = {
      division: filterData.division,
      dataView: filterData.dataView,
      topLevelContractGroup: filterData.topLevelContractGroup,
      secondLevelContractFilter: filterData.secondLevelContractFilter,
      thirdLevelContractFilter: filterData.thirdLevelContractFilter,
      fourthLevelContractFilter: filterData.fourthLevelContractFilter,
      accts: filterData.accts,
      oneCustomerName: this.oneCustomerName,
      oneCustomerFilters: this.advancedOneCustomerFilters,
      excludeDeletedAccounts: filterData.excludeDeletedAccounts
    };

    let url = `${this.ENDPOINT_BASE_PATH}/service-insight/${issueType}?region=${filterData?.regions}&countries=${filterData?.countries}&period=${filterData?.period}`;
    url = this.filterService.appendCustomDateRangeToUrl(url);
    return await this.httpClientService.post(
      url,
      payload
    );
  }

  async getPestKPITotalLocationsServiced() {
    let filterData: ContractModel | undefined =
      this.filterService.selectedFilters.getValue();

    if (filterData == undefined) {
      throw new Error('filterData is undefined');
    }

    const payload = {
      division: filterData.division,
      dataView: filterData.dataView,
      topLevelContractGroup: filterData.topLevelContractGroup,
      secondLevelContractFilter: filterData.secondLevelContractFilter,
      thirdLevelContractFilter: filterData.thirdLevelContractFilter,
      fourthLevelContractFilter: filterData.fourthLevelContractFilter,
      accts: filterData.accts,
      oneCustomerName: this.oneCustomerName,
      oneCustomerFilters: this.advancedOneCustomerFilters
    };

    let url = `${this.ENDPOINT_BASE_PATH}/total-locations-serviced?region=${filterData?.regions}&countries=${filterData?.countries}&period=${filterData?.period}`;
    url = this.filterService.appendCustomDateRangeToUrl(url);
    return await this.httpClientService.post(
      url,
      payload
    );
  }

  async getPestKPITotalCallsClosed() {
    let filterData: ContractModel | undefined =
      this.filterService.selectedFilters.getValue();

    if (filterData == undefined) {
      throw new Error('filterData is undefined');
    }

    const payload = {
      division: filterData.division,
      dataView: filterData.dataView,
      topLevelContractGroup: filterData.topLevelContractGroup,
      secondLevelContractFilter: filterData.secondLevelContractFilter,
      thirdLevelContractFilter: filterData.thirdLevelContractFilter,
      fourthLevelContractFilter: filterData.fourthLevelContractFilter,
      accts: filterData.accts,
      oneCustomerName: this.oneCustomerName,
      oneCustomerFilters: this.advancedOneCustomerFilters
    };

    let url = `${this.ENDPOINT_BASE_PATH}/total-calls-closed?region=${filterData?.regions}&countries=${filterData?.countries}&period=${filterData?.period}`;
    url = this.filterService.appendCustomDateRangeToUrl(url);
    return await this.httpClientService.post(
      url,
      payload
    );
  }
  async getTotalScanPestCountKPI(){
    try{
      if (this.filterSet == undefined) {
        throw new Error('filterData is undefined');
      }
      const payload = {
        ...this.filterSet,
        CurrencyCode: this.currencyUomService.getCurrency(),
        UnitOfMeasure: this.currencyUomService.getUom(),
      };
      let url = `${this.ENDPOINT_BASE_PATH}/total-scan-pest-count`;
     return await this.httpClientService.post(
        url,
        payload);
    }catch(error){
      console.error('Error getting total scan pest count', error);
      return axios('fail');
    }
  }

  async getServiceDetailsAdvFilters(callType?: SICallTypes) {
    let filterData: ContractModel | undefined =
    this.filterService.selectedFilters.getValue();

    if (filterData == undefined) {
      throw new Error('filterData is undefined');
    }

    const payload = {
      division: filterData.division,
      dataView: filterData.dataView,
      topLevelContractGroup: filterData.topLevelContractGroup,
      secondLevelContractFilter: filterData.secondLevelContractFilter,
      thirdLevelContractFilter: filterData.thirdLevelContractFilter,
      fourthLevelContractFilter: filterData.fourthLevelContractFilter,
      accts: filterData.accts,
      oneCustomerName: this.oneCustomerName,
      oneCustomerFilters: this.advancedOneCustomerFilters,
      excludeDeletedAccounts: filterData.excludeDeletedAccounts
    };

    let callTypeFilter = callType ? `callType=${callType}&` : '';

    let url = `${this.ENDPOINT_BASE_PATH}/service-details/filters?${callTypeFilter}region=${this.filterRequest?.regions}&countries=${this.filterRequest?.countries}&period=${this.filterRequest?.period}`;
    url = this.filterService.appendCustomDateRangeToUrl(url);
    return await this.httpClientService.post(
      url,
      payload
    );
  }

  /**
   * Fetches the KPI card data for the specified service insights call type.
   * @param serviceMetricType The type of service insights call for which to retrieve KPI data.
   */
  async getServiceDetailsKpiData(serviceMetricType: SICallTypes) {
    try {
      if (this.filterSet == undefined) {
        throw new Error('filterData is undefined');
      }
      const payload = {
        ...this.filterSet,
        CurrencyCode: this.currencyUomService.getCurrency(),
        UnitOfMeasure: this.currencyUomService.getUom(),
      };
      let url = `${this.ENDPOINT_BASE_PATH}/service-details/kpi-cards/${serviceMetricType}`;
      return await this.httpClientService.post(
        url,
        payload
      );
    } catch (error) {
      console.error('Error getting service details KPI data', error);
      return axios('fail');
    }
  }
}
